module.exports = __webpack_public_path__ + "img/Yellow.fd2d7968.png";